/**
 * Maps a recommend hit to the Product shape expected by ModernProduct/Fieldset.
 * The search index holds numeric values (price, amount) while ModernProduct expects strings.
 */
export const mapHitToProduct = (hit: Record<string, any>) => ({
  product_id: String(hit.product_id ?? hit.objectID),
  product: hit.product ?? '',
  seo_name: hit.seo_name ?? String(hit.product_id ?? hit.objectID),
  product_code: hit.product_code ?? '',
  price: String(hit.price ?? 0),
  base_price: String(hit.base_price ?? 0),
  list_price: String(hit.list_price ?? 0),
  amount: String(hit.amount ?? 0),
  infiniteStock: hit.infiniteStock ?? false,
  coeffQuantity: hit.coeffQuantity ?? 1,
  brand_name: hit.brand_name ?? '',
  brand_seo_name: hit.brand_seo_name ?? '',
  brand_variant_id: hit.brand_variant_id ?? '',
  company_id: String(hit.company_id ?? ''),
  company_name: hit.company_name ?? '',
  company_seo_name: hit.company_seo_name ?? '',
  main_pair: hit.main_pair ?? null,
  image_pairs: hit.image_pairs ?? [],
  // Preuve sociale : présent seulement si le chiffre atteint le seuil d'anonymat.
  social_proof_buyers: hit.social_proof_buyers,
  // Raison affichée sur les nouveaux blocs, quand le serveur la donne.
  common_buyers: hit.common_buyers,
  reorder_reason: hit.reorder_reason,
  reorder_qty: hit.reorder_qty,
  reorder_reference_ts: hit.reorder_reference_ts,
  reorder_interval_days: hit.reorder_interval_days,
  reorder_days_since: hit.reorder_days_since,
})
